/**
 * PageHeader Component
 * Standardized page header component following consistent design patterns across the application
 */

import { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  description?: string
  badge?: ReactNode
  actions?: ReactNode
}

export function PageHeader({ title, description, badge, actions }: PageHeaderProps) {
  return (
    <div className="space-y-2">
      <div className={actions ? "flex flex-wrap items-center justify-between gap-3" : ""}>
        <div className="flex items-center gap-2">
          <h2 className="text-2xl font-bold bg-gradient-to-r from-brand-blue to-brand-cyan bg-clip-text text-transparent">
            {title}
          </h2>
          {badge}
        </div>
        {actions && <div className="flex gap-2">{actions}</div>}
      </div>
      {description && (
        <p className="text-muted-foreground">
          {description}
        </p>
      )}
    </div>
  )
}
